function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5.4658,
    height: 5.4658,
    viewBox: "0 0 1.4462 1.4462",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45)",
    cx: 0.0000050205,
    cy: 1.0226,
    r: 0.72309,
    style: {
      fillRule: "evenodd",
      fill: "#000000",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.40175 1.0443.64319-.64319",
    style: {
      fill: "none",
      strokeWidth: 0.13229,
      stroke: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.0449 1.0443-.64319-.64319",
    style: {
      fill: "none",
      strokeWidth: 0.13229,
      stroke: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.edaeca62cbefc04e1f5708bd51075c48.svg";
export { ForwardRef as ReactComponent };